import React from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CompanyNameItem from '../companyNameItem/companyNameItem';
import { useAuth } from "../../../context/AuthContext";
import { UserRole } from "../../../enums/user";
import { useCompany } from "../../../context/CompanyContext";
import { Company } from "../../../interfaces/company.interface";

interface ChangeCompanyDialogProps {
  show: boolean;
  onClose: () => void;
}

const ChangeCompanyDialog: React.FC<ChangeCompanyDialogProps> = ({ show, onClose }) => {
  const { user, updateCompanyVisited } = useAuth()
  const { companies: companyList } = useCompany();

  const handleCompanyChange = (company: Company) => {
    if (user?.user) {
      updateCompanyVisited(company);
      onClose();
      window.location.reload();
    }
  }

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={show}
      sx={{
        [`.MuiDialogContent-root`]: {
          padding: '1em 0',
        },
      }}
    >
      
      <DialogTitle sx={{ marginRight: '4em', padding: '.5em' }} id="customized-dialog-title">
        Escolha a Organização
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 2,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
     

      <DialogContent dividers>
        {user?.user?.role === UserRole.sAdmin && companyList
          .slice()
          .sort((a, b) => a.name_company.localeCompare(b.name_company))
          .map(company => (
            <CompanyNameItem
              key={company.id}
              companyName={company.name_company}
              onClick={() => handleCompanyChange(company)}
            />
        ))}
      </DialogContent>
    </Dialog>
  );
}

export default ChangeCompanyDialog;
